// extracted by extract-css-chunks-webpack-plugin
module.exports = {"authorContainer":"_3kMXO5"};